// extracted by mini-css-extract-plugin
export default {"root":"LxuReb_9IqXQ1YrAxX4W"};